<script>
    import {sgettext} from '../../i18n.js';
    import Modal from '../Modal.svelte';
    export let id = 'instanceFailureReasons';
</script>

<Modal
  id="instanceFailureReasons"
  large={true}
  title={sgettext('$$INSTANCE_CREATION_FAILURE$$')}
>
  <div slot="body">
    <div class="metadata-container">
      <span class="metadata-title">{sgettext('$$CURRENT_TEMPLATE$$')}:</span><br
      />
      <span class="metadata-value"
        >{sgettext(
          "$$INSTANCE_CREATED_ACTIVITY_CURRENT_EXISTS$$"
        )}</span
      >
      <span class="metadata-value"
        >{sgettext(
          '$$CURRENT_TEMPLATE_EXISTS_SYSTEM_CHECK$$'
        )}</span
      >
      <br />
      <span class="metadata-title">{sgettext('$$OPERATION_MISMATCH$$')}:</span><br
      />
      <span class="metadata-value"
        >{sgettext(
          "$$INSTANCE_CANNOT_CREATED_OPERATIONS_NOT$$"
        )}</span
      ><br /><br />
      <ul>
        <li>
          <span class="metadata-title sub-title"
            >{sgettext('$$BYPASS_CHECK_RERUN$$')}:</span
          ><br />
        </li>
        <span class="metadata-value"
          >{sgettext(
            '$$BYPASS_OPERATION_CHECK_AFFECTED_WORK$$'
          )}</span
        >
        <li>
          <span class="metadata-title sub-title"
            >{sgettext('$$EDIT_MAPPING$$')}:</span
          ><br />
        </li>
        <span class="metadata-value"
          >{sgettext(
            '$$OPERATION_MAPPING_ADJUSTED_TEMPLATE_WORK$$'
          )}</span
        >
      </ul>
      <p>
        <span class="metadata-title">{sgettext('$$UNMAPPED_SEQUENCES$$')}:</span><br
        />
        <span class="metadata-value"
          >{sgettext(
            "$$INSTANCE_CANNOT_CREATED_SEQUENCES_NOT$$"
          )}</span
        >
      </p>
    </div>
  </div>
  <div slot="footer" />
</Modal>

<style>
  .metadata-title {
    font-weight: bold;
    font-size: 1.7em;
    font-family: arial, sans-serif;
  }

  .sub-title {
    font-size: 1.5em;
  }

  .metadata-value {
    font-size: 1.2em;
    color: grey;
  }

  .metadata-container {
    margin: 0;
  }
</style>
